import { render, staticRenderFns } from "./PrivateStartupProfile.vue?vue&type=template&id=241571bb&"
import script from "./PrivateStartupProfile.vue?vue&type=script&lang=js&"
export * from "./PrivateStartupProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports